module.exports = __webpack_public_path__ + "img/stop.5bb59bcb.svg";